export const login = {
  'login.title': 'Prijavite se v svoj uporabniški račun',
  'login.description': 'Še nimate uporabniškega računa?',
  'login.createAccount': 'Ustvarite uporabniški račun',
  'login.login': 'Prijava',
}
